import { defineMessages, injectIntl } from 'react-intl';
import React from 'react';
import Grid from '../../components/Grid';
import { ReactComponent as SchoolSvg } from './school.svg';
import PropTypes from 'prop-types';

const messages = defineMessages({
  hmm: {
    id: 'main.container.nodata.hmm',
    defaultMessage: 'Hmm...',
  },
  noInfo: {
    id: 'main.container.nodata.noInfo',
    defaultMessage: 'No information is available for this college.',
  },
  helpfulLinks: {
    id: 'main.container.nodata.helpfulLinks',
    defaultMessage: 'Here are some helpful links that might get you back on track:',
  },
  superMatch: {
    id: 'main.container.nodata.supermatch',
    defaultMessage: 'SuperMatch',
  },
  collegeMatch: {
    id: 'main.container.nodata.collegematch',
    defaultMessage: 'CollegeMatch',
  },
  collegeHome: {
    id: 'main.container.nodata.collegehome',
    defaultMessage: 'College: Home',
  },
  collegeSearch: {
    id: 'main.container.nodata.collegeSearch',
    defaultMessage: 'College Search',
  },
  planMyTransferPath: {
    id: 'main.container.nodata.planMyTransferPath',
    defaultMessage: 'Plan My Transfer Path',
  },
  adviceAndStories: {
    id: 'main.container.nodata.adviceAndStories',
    defaultMessage: 'Advice and Stories',
  },
});

function NoDataComponent({ intl, getUrls, isCamino }) {
  const urls = isCamino ? getUrls({}) : {};
  return (
    <div className="main-container-no-data">
      <Grid stackable className="main-container-no-data-grid">
        <Grid.Row>
          <Grid.Column className="main-container-no-data-svg-column">
            <div aria-hidden="true">
              <SchoolSvg className="main-container-no-data-svg" />
            </div>
          </Grid.Column>
          <Grid.Column className="main-container-no-data-text-column">
            <p className="main-container-no-data-hmm">
              {intl.formatMessage(messages.hmm)}
            </p>
            <p className="main-container-no-data-subheading">
              {intl.formatMessage(messages.noInfo)}
            </p>
            <p className="main-container-no-data-text">
              {intl.formatMessage(messages.helpfulLinks)}
            </p>
            <Grid stackable className="main-container-no-data-grid">
              {isCamino ? (
                <>
                  <Grid.Row className="main-container-no-data-links-row">
                    <a href={urls.collegeSearch}>
                      {intl.formatMessage(messages.collegeSearch)}
                    </a>
                  </Grid.Row>
                  <Grid.Row className="main-container-no-data-links-row">
                    <a href={urls.planMyTransferPath}>
                      {intl.formatMessage(messages.planMyTransferPath)}
                    </a>
                  </Grid.Row>
                  <Grid.Row className="main-container-no-data-links-row">
                    <a href={urls.adviceAndStories}>
                      {intl.formatMessage(messages.adviceAndStories)}
                    </a>
                  </Grid.Row>
                </>
              ) : (
                <>
                  <Grid.Row className="main-container-no-data-links-row">
                    <a href="/colleges/supermatch-next">
                      {intl.formatMessage(messages.superMatch)}
                      <sup>&reg;</sup>
                    </a>
                  </Grid.Row>
                  <Grid.Row className="main-container-no-data-links-row">
                    <a href="/colleges/match/looking-for-you">
                      {intl.formatMessage(messages.collegeMatch)}
                    </a>
                  </Grid.Row>
                  <Grid.Row className="main-container-no-data-links-row">
                    <a href="/colleges">{intl.formatMessage(messages.collegeHome)}</a>
                  </Grid.Row>
                </>
              )}
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
}

NoDataComponent.propTypes = {
  props: PropTypes.object,
  getUrls: PropTypes.func,
  isCamino: PropTypes.bool,
};

export default injectIntl(NoDataComponent);
